import React, { useState } from "react";
import { Drawer, Toolbar, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Box } from "@mui/material";
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import IconButton from '@mui/material/IconButton';
import useResponsive from "../../utils/useResponsive";
import { replace, useNavigate } from "react-router-dom";
import AssessmentIcon from '@mui/icons-material/Assessment';
import GroupsIcon from '@mui/icons-material/Groups';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import SendIcon from '@mui/icons-material/Send';
import { isStudent, useAuth } from "../../contexts/AuthContext";
import DoubleArrowRoundedIcon from '@mui/icons-material/DoubleArrowRounded';
import CommentIcon from '@mui/icons-material/Comment';
import PreviewIcon from '@mui/icons-material/Preview';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';


const InternalLeftNavBar = ({ open, closeNav }) => {
    const drawerWidth = 240;
    const isDesktop = useResponsive('up', 'md');
    const navigate = useNavigate();
    console.log(window.location.pathname.split("/")[2])
    const path = window.location.pathname.split("/")[2]
    const renderContent = (
        <Box sx={{ overflow: 'auto', scrollbarWidth: 'thin' }}>
            <List>
            <ListItem disablePadding>
                    <ListItemButton onClick={() => { navigate('/internal/generatequestions', { replace: false }) }}>
                        <ListItemIcon>
                            <AddCircleOutlineIcon />
                        </ListItemIcon>
                        <ListItemText primary="New Questions" />
                        {(path === "generatequestions") && <DoubleArrowRoundedIcon sx={{color: "primary.main"}}/>}
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton onClick={() => { navigate('/internal/qareview', { replace: false }) }}>
                        <ListItemIcon>
                            <PreviewIcon />
                        </ListItemIcon>
                        <ListItemText primary="QA Review" />
                        {(path === "qareview") && <DoubleArrowRoundedIcon sx={{color: "primary.main"}}/>}
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton onClick={() => { navigate('/internal/feedback', { replace: false }) }}>
                        <ListItemIcon>
                            <CommentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Feedback" />
                        {(path === "feedback") && <DoubleArrowRoundedIcon sx={{color: "primary.main"}}/>}
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton onClick={() => { navigate('/internal/qastats', { replace: false }) }}>
                        <ListItemIcon>
                            <AssessmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="QA Stats" />
                        {(path === "qastats") && <DoubleArrowRoundedIcon sx={{color: "primary.main"}}/>}
                    </ListItemButton>
                </ListItem>
            </List>
            <Divider />
        </Box>
    )

    return (
        <Box>
            {isDesktop ? (
                <Drawer
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                        },
                    }}
                    variant="permanent"
                    anchor="left"
                >
                    <Toolbar></Toolbar>
                    {renderContent}
                </Drawer>
            ) : (
                <Drawer
                    open={open}
                    onClose={closeNav}
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                        },
                    }}
                    anchor="left"
                    onClick={closeNav}
                >
                    <Toolbar></Toolbar>
                    {renderContent}
                </Drawer>)
            }
        </Box>
    );
}

export default InternalLeftNavBar;